import {observable, action, runInAction} from 'mobx'
import {json, get} from '../../../utils/ajax'
import {handleSeerchAndPage, setStore, ValueObjToObj} from '../../../utils/Utils'
import {message} from "antd";

class AssemblyTempStore {

    @observable loading //数据加载
    @observable pagination //分页
    @observable searchFields //表单绑值
    @observable list //页面数据
    @observable importReturnData //存储导入返回值
    @observable showDrawer //开启导入数据抽屉
    @observable notMatched //已完成数量
    @observable hasMatched //未完成数量


    constructor() {
        this.loading = false
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchFields = {}
        this.list = []
        this.importReturnData = []
        this.showDrawer = false
        this.notMatched = ''
        this.hasMatched = ''
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 页面初始化
     * @param page
     * @returns {Promise<void>}
     */
    @action
    initPage = async (page) => {
        this.loading = true
        let search = handleSeerchAndPage(page, this.pagination, this.searchFields)
        search.size = this.pagination.pageSize
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp:search`, search)
        const notMatched = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/theNumberOfBackupPartsDidNotMatch`)
        const hasMatched = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/theNumberOfBackupPartsHasBeenMatched`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.notMatched = notMatched
            this.hasMatched = hasMatched
            this.loading = false
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
        })
    }

    /**开启导入返回数据抽屉**/
    @action
    onUpload = (arr) => {
        this.importReturnData = arr
        this.showDrawer = true
    }

    /**关闭导入返回数据抽屉**/
    @action
    onClose = () => {
        this.showDrawer = false
    }

    /**
     * 将页面的值绑到store
     * @param changedFields
     */
    @action
    onSearchFieldChange = (changedFields) => {
        this.searchFields = {...this.searchFields, ...ValueObjToObj(changedFields)}
    }

    /**
     * 重置
     * @returns {Promise<void>}
     */
    @action
    clearForm = async () => {
        this.searchFields = {}
        await this.initPage()
    }

    /**
     * 刪除
     */
    @action
    deleteSparepartDefination = async (id) => {
        runInAction(() => {
            this.loading = true
        })
        const res = await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/deleteProcessedData`)
        if (res && res.status >= 400) {
            return
        }
        runInAction(() => {
            message.success('删除成功')
            this.loading = false
        })
        await this.initPage(this.pagination.current)
    }

    /**
     * 处理
     */
    @action
    dealWith = async (level) => {
        this.loading = true
        let res = {}
        if(level === 1){
            res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/processMatchingBackupParts`)
        }else{
            res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/processSubBackupParts`)
        }
        if (!res.status) {
            message.warning('处理失败！')
            this.loading = false
            return
        }
        message.success("处理完成")
        const notMatched = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/theNumberOfBackupPartsDidNotMatch`)
        const hasMatched = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/theNumberOfBackupPartsHasBeenMatched`)
        runInAction(() => {
            this.notMatched = notMatched
            this.hasMatched = hasMatched
            this.loading = false
        })
    }


    /**
     * 匹配数据
     */
    @action
    matchData = async (level) => {
        this.loading = true
        let res = {}
        if(level === 1){
             res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/matchingBackupParts`)
        }else{
             res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/matchLowerLevelBackupParts`)
        }
        if (!res.status) {
            message.warning('匹配失败！')
            this.loading = false
            return
        }
        message.success("匹配完成")
        const notMatched = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/theNumberOfBackupPartsDidNotMatch`)
        const hasMatched = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/theNumberOfBackupPartsHasBeenMatched`)
        runInAction(() => {
            this.notMatched = notMatched
            this.hasMatched = hasMatched
            this.loading = false
        })
    }


    //迁移
    @action
    dataMigration=async ()=>{
        this.loading = true
        const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/assemblyTemp/migrateBackupPartData`)
        if (!res.status) {
            message.warning('迁移失败！')
            this.loading = false
            return
        }
        this.loading = false
        message.success("迁移完成")
    }
}

export default new AssemblyTempStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/AssemblyTemp/store.js